/**
 * ScrollTriggerController
 * .scroll-trigger[data-target] のクリックで、
 * #{data-target} のセクションへスムーズスクロールする。
 *
 * - Lenis があれば lenis.scrollTo() を使用（duration 統一・慣性 easing）
 * - 無ければ window.scrollTo({ behavior: 'smooth' }) にフォールバック
 * - #header (fixed) の高さ分だけ手前に止めて、見出しが隠れないようにする
 * - 開いていれば MenuController.close() で nav を閉じる
 *
 * ★ Barba 対応: .scroll-trigger は menu.php / footer.php (barba container 外) にも
 *   存在するため、DOM は遷移で入れ替わらない。init が繰り返し呼ばれる度に
 *   前回の listener を解除してから貼り直し、handler の重複を防ぐ。
 */
import { LenisController } from './lenis-controller';
import { MenuController }  from './menu-controller';

export const ScrollTriggerController = {
  _bindings: [], // [ [ el, handler ], ... ] 前回登録分の解除用

  init() {
    // 前回分の listener を解除
    this._bindings.forEach( ( [ el, handler ] ) => {
      el.removeEventListener( 'click', handler );
    } );
    this._bindings = [];

    const triggers = document.querySelectorAll( '.scroll-trigger[data-target]' );
    if ( !triggers.length ) return;

    triggers.forEach( ( trigger ) => {
      const handler = ( e ) => {
        const target = document.getElementById( trigger.dataset.target );
        // 対象セクションが現在のページに無ければ preventDefault せず
        // 通常のリンク遷移に任せる (下層ページ → front-page の hash リンクとして機能)
        if ( !target ) return;
        e.preventDefault();

        // ハンバーガーメニューが開いていれば閉じる
        MenuController.close?.();

        // 固定ヘッダー分のオフセット
        //  - CSS の top(23.5) + height(38) = 見えている状態の "底" を算出
        //  - getComputedStyle().top を使うため、.hide の transform に影響されない
        const header = document.querySelector( '#header' );
        let offset = 0;
        // if ( header ) {
        //   const cssTop = parseFloat( getComputedStyle( header ).top ) || 0;
        //   const height = header.getBoundingClientRect().height;
        //   offset = cssTop + height;
        // }

        if ( LenisController.lenis ) {
          LenisController.lenis.scrollTo( target, {
            offset: -offset,
          } );
        } else {
          const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo( { top: y, behavior: 'smooth' } );
        }
      };
      trigger.addEventListener( 'click', handler );
      this._bindings.push( [ trigger, handler ] );
    } );
  },
};
